import { useEffect, useState } from 'react'

//import { InstructorBase } from './../../../../Layouts/Instructor/InstructorBase'
import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'

import { Loading } from './../../../../Common/Loading'
import { LogErrors } from './../../../../../utilities/LogErrors'
import { useFloatMessage, MESSAGE_TYPE } from './../../../../Providers/FloatMessage'

import { GetCenterSettings as BLGetCenterSettings, SetCenterSettings as BLSetCenterSettings } from './../../../../../utilities/BL/Instructor/Settings'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'
//import { useTawkChat } from './../../../../../Support/Chat/Chat'


const Toggle = ({ id, checked, onChange, labelLeft, labelRight, disabled }) => {
    return (
        <label className="Toggle__Row">
            {labelLeft && <span className="Toggle__Label">{labelLeft}</span>}

            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-labelledby={id ? `${id}-lbl` : undefined}
                className={`Toggle ${checked ? 'is-on' : 'is-off'} ${disabled ? 'is-disabled' : ''}`}
                onClick={() => !disabled && onChange(!checked)}
                onKeyDown={(e) => {
                    if (disabled) return
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        onChange(!checked)
                    }
                }}
            >
                <span className="Toggle__Thumb" />
            </button>
            {labelRight && (
                <span id={id ? `${id}-lbl` : undefined} className="Toggle__Label Toggle__Label--Right">{labelRight}</span>
            )}
        </label>
    )
}

const initialState = {
    isTheoryVisible: false,
    isQuizzVisible: false,
    isVideoVisible: false,
    isChallengeVisible: false,
    isActivityVisible: false,
    isEvaluationVisible: false
}

const Settings = () => {
  const { showMessage } = useFloatMessage()

  const [isLoading, setIsLoading] = useState(true)
  const [isWorking, setIsWorking] = useState(false)

  const [serverSettings, setServerSettings] = useState(initialState) // última versión del server
  const [form, setForm] = useState(initialState)                      // estado editable en UI

  const setField = (key) => (value) => setForm(prev => ({ ...prev, [key]: value }))

  const isDirty = JSON.stringify(form) !== JSON.stringify(serverSettings)


  const UpdateSettings = async () => {
    try {
        setIsWorking(true)

        const payload = { ...form } // lo que vas a enviar
        
        const response = await BLSetCenterSettings(payload)
        
        if (response?.success) {
            setServerSettings(payload) // sincroniza base
            showMessage({
                type: MESSAGE_TYPE.SUCCESS,
                text: 'Se han actualizado y aplicado las configuraciones de manera exitosa.'
            })
        } else {
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: response?.message || 'No fue posible guardar los cambios.'
            })
        }
    } catch (error) {
        await LogErrors('UpdateSettings - Settings', error)
        showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ocurrió un error al guardar.' })
    } finally {
        setIsWorking(false)
    }
  }

  const LoadPage = async () => {
    try {
        const response = await BLGetCenterSettings()
        
        if (response?.success && response?.data) {
            const data = { ...initialState, ...response.data }
            setServerSettings(data)
            setForm(data)
        } else {
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: response?.message || 'No ha sido posible obtener las configuraciones.'
            })
        }
    } catch (error) {
        await LogErrors('LoadPage - Settings', error)
        showMessage({ type: MESSAGE_TYPE.BAD, text: 'No ha sido posible obtener las configuraciones.' })
    } finally {
        setIsLoading(false)
    }
  }

  useEffect(() => {
    LoadPage()
  }, [])


  //useTawkChat(true) // Activamos el chat en esta página


  return (
    isLoading ? (
        <Loading />
    ) : (
        <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.INSTRUCTOR.SETTINGS} role={ROLES.INSTRUCTOR}>
            <main className='container Instructor__Ztudents'>
                <p className='Instructor__Title Instructor__Title--Center'>Configuraciones</p>

                <section className='Instructor__SpaceUp Instructor__Settings__Sections Tables--Shadow Tables--Background'>
                    <p className='mb-1 fw-bold text-center'>Ztudiante</p>
                    <p className='mb-3 text-center'>Activa o desactiva las opciones deseadas:</p>

                    <div className='Settings__Options'>
                        <Toggle
                            id='theory'
                            labelLeft='Teorías'
                            checked={form.isTheoryVisible}
                            onChange={setField('isTheoryVisible')}
                            disabled={isWorking}
                        />
                        <Toggle
                            id='quizz'
                            labelLeft='Cuestionarios'
                            checked={form.isQuizzVisible}
                            onChange={setField('isQuizzVisible')}
                            disabled={isWorking}
                        />
                        <Toggle
                            id='video'
                            labelLeft='Videos'
                            checked={form.isVideoVisible}
                            onChange={setField('isVideoVisible')}
                            disabled={isWorking}
                        />
                        <Toggle
                            id='challenge'
                            labelLeft='Desafíos'
                            checked={form.isChallengeVisible}
                            onChange={setField('isChallengeVisible')}
                            disabled={isWorking}
                        />
                        <Toggle
                            id='activity'
                            labelLeft='Actividades'
                            checked={form.isActivityVisible}
                            onChange={setField('isActivityVisible')}
                            disabled={isWorking}
                        />
                        <Toggle
                            id='evaluation'
                            labelLeft='Evaluaciones'
                            checked={form.isEvaluationVisible}
                            onChange={setField('isEvaluationVisible')}
                            disabled={isWorking}
                        />
                    </div>
                </section>

                <section className='Instructor__Settings__Buttons'>
                    {isWorking ? (
                        <p className='Btn__Ztudia--PrimaryOutline mb-0 mx-auto text-center Instructor__Settings__Buttons__Button'>Guardando…</p>
                    ) : (
                        <button type='button' className='Btn__Ztudia--Primary mx-auto Instructor__Settings__Buttons__Button' onClick={UpdateSettings} disabled={!isDirty} title={!isDirty ? 'No hay cambios por guardar' : undefined}>Guardar cambios</button>
                    )}
                </section>
            </main>
        </InstructorBase>
    )
  )
}

export { Settings };